import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import styled from "@emotion/styled";
import {Exist} from "views/components/exist/exist.component";
import {IRosterPlayerTournamentInfoController} from "views/components/roster/roster_player_tournament_info/roster_player_tournament_info.controller";

const Wrapper = styled.div`
	padding: 0 8px;
	border-radius: 24px;
	height: 18px;
	background: var(--secondaryColor);
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;

	span {
		color: var(--neutral100) !important;
		font-size: 10px !important;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 100%; /* 10px */
	}

	&.live {
		background: var(--secondaryColor);
	}

	&.complete {
		background: var(--primaryColor);
	}
`;

interface IProps {
	playerId: number;
}

export const RosterPlayerTournamentInfo: React.FC<IProps> = observer(({playerId}) => {
	const {
		pillClass,
		isTournamentLive,
		isTournamentComplete,
		isHomePlayerSquad,
		homeScore,
		awayScore,
		inningState,
		inningOrdinal,
		winLoseSymbol,
	} = useViewController<IRosterPlayerTournamentInfoController>(
		Bindings.RosterPlayerTournamentInfoController,
		{playerId}
	);
	return (
		<Wrapper className={pillClass}>
			<Exist when={isTournamentLive}>
				<span>
					{inningState} {inningOrdinal}
				</span>
			</Exist>
			<Exist when={isTournamentComplete}>
				<span>{winLoseSymbol}</span>
			</Exist>
			<span>
				<Exist when={isHomePlayerSquad}>
					{homeScore}-{awayScore}
				</Exist>
				<Exist when={!isHomePlayerSquad}>
					{awayScore}-{homeScore}
				</Exist>
			</span>
		</Wrapper>
	);
});
